export default {
  30006: `Phone number cannot be texted because it is a landline or the carrier is unreachable. (30006)

To protect your texting reputation, you should stop texting this phone number.`,
  21614: `Phone number cannot be texted because it is a landline or invalid. (21614)

To protect your texting reputation, you should stop texting this phone number.`,
  30011: `Phone number cannot be texted because it cannot receive media messages. (30011)

To protect your texting reputation, you should stop texting this phone number.`,
  30005: `Phone number cannot be texted because it is a landline, no longer in service, or out of service range. (30005)

To protect your texting reputation, you should stop texting this phone number.`,
  21211: `Phone number cannot be texted because it is incorrectly formatted or invalid. (21211)

To protect your texting reputation, you should stop texting this number and check to make sure it is valid before retrying.`,
  21610: `Phone number cannot be texted because this contact has opted out of text communication and cannot be texted. (21610)

This contact must opt in by texting “start”, “yes”, or “unstop” to resubscribe.`,
  30003: `Text message cannot be delivered because the contact’s phone my be off or out of service. Please try again later.  (30003)

If problem persists, you may want to discontinue texting this number.`,
  30007: `Text message cannot be delivered because the content may be out of compliance with carrier guidelines or marked as spam. You can write a new message and attempt to resend. (30007)

Learn more about Messaging Best Practices to avoid compliance blockages and protect your texting reputation.`,
  11200: `Text message cannot be delivered because we were unable to connect to the messaging service at this time. (11200)

Please try to resend your message. If problem persists, contact support.`,
  30008: `Text message cannot be delivered because we were unable to connect to the phone carrier at this time. (30008)

Please try to resend your message. If problem persists, contact support.`,
  30019: `Text message cannot be delivered because is too big! We recommend sending a message that is less than 320 characters or smaller than 600KB. (30019)`,
  30023: `Text messages cannot be delivered because you have reached your daily message cap. You can send messages again tomorrow. (30023)

Contact support to learn more about your daily texting limit.`,
  30033: `Text message cannot be delivered because texting and calling have been suspended due to a high rate of failed messages or spam. (30033)

Contact support to learn how to restore text and calling for this account.`,
  30410: `Text message cannot be delivered due to a timeout error. Please try resending later. (30410)`,
  30500: `Text message cannot be delivered because of a temporary service disruption. Please try again later. (30500)`,
  30034: `Text messages cannot be delivered because your account has not completed Application to Person (A2P) registration. You must register your business on the account settings SMS Registration page in order to send texts through Brivity. (30034)`,
  30035: `Text messages cannot be delivered because your Application to Person (A2P) registration is being processed and should be resolved soon. (30035)

Please contact support if the issue does not resolve.`,
  30038: `Text message cannot be delivered because you cannot send one time password links. Try sending something else. (30038)`,
  30039: `Text message cannot be delivered because it may be responding to an auto-generated text. When two computers try to text, it can spiral into an infinite feedback loop. (30039)

You probably shouldn’t text this number, but you could try again later.`,
  30024: `Text message cannot be delivered because the numeric sender ID is not provisioned. Please contact support. (30024)`,
};
